module.exports = __webpack_public_path__ + "img/edit-svgrepo-com.8741e57c.svg";